<template>
  <div class="content">
    <div class="box">
      <div class="title" v-if="this.$route.query.linkname != '办事指南/详情'">
        <p>{{ name }}</p>
      </div>
      <!-- <div v-html="htmlContent" class="design-html" style="margin-top: 15px;text-align: left"></div> -->
      <div v-if="this.$route.query.linkname == '办事指南/详情'">
        <div class="title">{{ name }}</div>
        <div class="desc">
          <div>{{ createTime }} 来源：{{ releaseName }}</div>
          <div>
            字号:
            <span @click="() => checkFocus(0)" :class="returnFocus(0)">大</span>
            <span @click="() => checkFocus(1)" :class="returnFocus(1)">中</span>
            <span @click="() => checkFocus(2)" :class="returnFocus(2)">小</span>
          </div>
        </div>
      </div>
      <div class="design-html" :style="size ? `font-size: ${size};` : ''" v-html="htmlContent"></div>
    </div>
  </div>
</template>

<script>
import { getHtml } from '@/api/html.js'
export default {
  name: 'middle-content',
  data () {
    return {
      name: '',
      linkname: '',
      createTime: '',
      htmlContent: '',
      releaseName: '',
      focus: 1,
      size: '18px',
    }
  },
  created () {
    this.name = this.$route.query.name
    console.log('000', this.$route.query);
    this.linkname = this.$route.query.linkname
    console.log('hidden', this.$route);
    this.getHtml();
  },
  computed: {
    returnFocus: function () {
      const self = this
      return function (val) {
        return self.focus === val && 'focus'
      }
    }
  },
  methods: {
    checkFocus (val) {
      const obj = {
        0: '22px',
        1: '18px',
        2: '14px'
      }
      this.focus = val
      this.size = obj[val]
    },
    getHtml () {
      console.log('*****', this.$route.query.contentCode)
      const contentCode = this.$route.query.contentCode
      const type = this.$route.query.type
      getHtml(contentCode, type).then(res => {
        this.htmlContent = this._.get(res, 'data.contentHtml', '')
        console.log('1223131213', res);
        this.createTime = this._.get(res, 'data.createTime', '')
        this.releaseName = this._.get(res, 'data.releaseName', '')
        // this.htmlContent = this.htmlContent.replace(/\s/g,'&nbsp;')
      })
    }
  },

}
</script>

<style scoped lang='less'>
.desc {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;
  > div:nth-of-type(1) {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #bcbec0;
    line-height: 80px;
  }
  > div:nth-of-type(2) {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #7f7f7f;
    line-height: 80px;
    > span {
      color: #333333;
      margin-right: 5px;
      padding: 0 3px;
      cursor: pointer;
    }
    > span.focus {
      border: 1px solid #cab484;
      color: #cab484;
    }
  }
}
/deep/.design-html {
  width: 1140px;
  text-align: left;
  margin-top: 60px;
  margin-bottom: 49px;
  margin-top: 15px;
  // text-indent: 2em;
  // white-space: pre-wrap;
  text-align: justify !important;
  text-justify: inter-ideograph;
  // ul li{
  //   list-style: none; 
  // }
}
/deep/.design-html > p {
  text-indent: 10px;
}
// /deep/p.ql-align-center {
//   text-indent: 2em !important;
// }
// .design-html p:after {
//   content: " ";
//   display: inline-block;
//   width: 100%;
// }
.content {
  width: 100%;
  position: relative;
  margin-bottom: 50px;
}
.box {
  width: 1140px;
  position: relative;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
}
//.title {
//  text-align: left;
//  font-size: 30px;
//  font-family: Microsoft YaHei;
//  font-weight: bold;
//  color: #333333;
//  line-height: 41px;
//  margin-top: 56px;
//  & > p {
//    display: inline-block;
//    padding-bottom: 5px;
//    /* border-bottom:  2px solid #CBB486; */
//    margin-bottom: 0;
//  }
//}
// .title {
//   font-size: 30px;
//   font-family: Microsoft YaHei;
//   font-weight: bold;
//   color: #000000;
//   line-height: 41px;
//   text-align: left;
//   margin-top: 30px;
// }
.title {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  line-height: 41px;
  text-align: left;
  margin-top: 30px;
  & > p {
    display: inline-block;
    padding-bottom: 5px;
    border-bottom: 2px solid #cbb486;
    margin-bottom: 0;
  }
}
.li-box {
  display: flex;
  width: 100%;
  text-align: left;
  border-bottom: 1px solid #eeeeee;
  cursor: pointer;
  & > div:nth-of-type(1) {
    /* flex: 1; */
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #3d4652;
    line-height: 80px;
    &:hover {
      color: #cbb486;
    }
  }
  & > div:nth-of-type(1)::before {
    content: "";
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #cbb486;
    margin-right: 10px;
    transform: translateY(-2px);
  }
  & > div:nth-of-type(2) {
    flex: 100px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #bcbec0;
    text-align: right;
    line-height: 80px;
  }
}
/deep/ .ant-pagination-item-active {
  border: none;
  background: #cbb486;
}
/deep/ .ant-pagination-item-active a {
  color: white;
}
/deep/ .ant-pagination-item:hover {
  background: #cbb486;
  border: none;
  color: white;
}
/deep/ .ant-pagination-item:hover a {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/home/htmlContent/siderContent-01.vue